export const cropStyle = (position, zoom) => ({
  objectPosition: position || undefined,
  transform: zoom && zoom !== 1 ? `scale(${zoom})` : undefined,
  transformOrigin: position || "center",
});
